__turbopack_context__.v({
  "bottomContent": "custom-footer-module__veZ_JW__bottomContent",
  "bottomLinks": "custom-footer-module__veZ_JW__bottomLinks",
  "bottomText": "custom-footer-module__veZ_JW__bottomText",
  "btmWrapper": "custom-footer-module__veZ_JW__btmWrapper",
  "divider": "custom-footer-module__veZ_JW__divider",
  "icon": "custom-footer-module__veZ_JW__icon",
  "link": "custom-footer-module__veZ_JW__link",
  "linkSection": "custom-footer-module__veZ_JW__linkSection",
  "links": "custom-footer-module__veZ_JW__links",
  "linksWrapper": "custom-footer-module__veZ_JW__linksWrapper",
  "logo": "custom-footer-module__veZ_JW__logo",
  "ozoneText": "custom-footer-module__veZ_JW__ozoneText",
  "root": "custom-footer-module__veZ_JW__root",
  "socialIcons": "custom-footer-module__veZ_JW__socialIcons",
  "socialLogo": "custom-footer-module__veZ_JW__socialLogo",
  "socialMedia": "custom-footer-module__veZ_JW__socialMedia",
  "title": "custom-footer-module__veZ_JW__title",
  "titleLinkSection": "custom-footer-module__veZ_JW__titleLinkSection",
  "topContent": "custom-footer-module__veZ_JW__topContent",
});
